module.exports = __webpack_public_path__ + "img/zhgy.83323493.svg";